import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { TITLE_HELP_PORTAL } from "@/lib/title-help";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/title/help/")({
  component: TitleHelpIndex,
});

export function TitleHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the title portal"
        className="mb-6"
      />
      <HelpCatalog
        search={search}
        onSearchChange={setSearch}
        catalog={TITLE_HELP_PORTAL}
      />
    </div>
  );
}
